import { CgSpinner } from "react-icons/cg";
import clsx from "clsx";

const LoadingSpinner = ({ className, size = 20 }) => {
  return <CgSpinner className={clsx("animate-spin", className)} size={size} />;
};

export default LoadingSpinner;
